// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2B8OR","image":"style_image__16Lx6","text":"style_text__1suVj","containerNew":"style_containerNew__2D5We","icon":"style_icon__1RhsD"};